import React from "react";
import PropTypes from "prop-types";
const SadFaceIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd" transform="translate(-3 -3)">
      <path d="M0 0h24v24H0z" />
      <path
        fill={color || "var(--color-easil-gray-x-dark)"}
        fillRule="nonzero"
        d="M8.616 14.39a1 1 0 0 0 1.691 1.067c.353-.56.966-.905 1.64-.905.686 0 1.31.359 1.66.936a1 1 0 0 0 1.71-1.036 3.935 3.935 0 0 0-3.37-1.9 3.935 3.935 0 0 0-3.331 1.838z"
      />
      <circle
        cx="9.6"
        cy="10.2"
        r="1.2"
        fill={color || "var(--color-easil-gray-x-dark)"}
      />
      <circle
        cx="14.2"
        cy="10.2"
        r="1.2"
        fill={color || "var(--color-easil-gray-x-dark)"}
      />
      <path
        fill={color || "var(--color-easil-gray-x-dark)"}
        fillRule="nonzero"
        d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18z"
      />
    </g>
  </svg>
);
SadFaceIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default SadFaceIcon;
